import category1 from "../assets/icon/category-1.png";
import category2 from "../assets/icon/category-2.png";
import category3 from "../assets/icon/category-3.png";
import category4 from "../assets/icon/category-4.png";
import category5 from "../assets/icon/category-5.png";
import category6 from "../assets/icon/category-6.png";
import category7 from "../assets/icon/category-7.png";
import category8 from "../assets/icon/category-8.png";
import category9 from "../assets/icon/category-9.png";
import category10 from "../assets/icon/category-10.png";
import category11 from "../assets/icon/category-11.png";
import category12 from "../assets/icon/category-12.png";
import category13 from "../assets/icon/category-13.png";
import category14 from "../assets/icon/category-14.png";
import category15 from "../assets/icon/category-15.png";
import category16 from "../assets/icon/category-16.png";
import category17 from "../assets/icon/category-17.png";
import category18 from "../assets/icon/category-18.png";
export const CategoriesData = [
  {
    name: "Chemicals",
    icon: category2,
    path:"chemicals",
    subCategories: [
      { name: "Detergent Chemicals", path: "detergents_chemicals" },
      { name: "Cleaning Chemicals", path: "cleaning_chemicals" },
      { name: "Disinfectant Chemicals", path: "disinfectant_chemicals" },
      { name: "Aquaculture", path: "disinfectant_chemicals" },
      { name: "Rubber", path: "disinfectant_chemicals" },
      { name: "Paint", path: "disinfectant_chemicals" },
      { name: "RO Membrane", path: "disinfectant_chemicals" },
      { name: "Food Feed And Pharma Grade", path: "disinfectant_chemicals" },
    ],
  },
  {
    name: "Powders",
    icon: category1,
    path:"powders",
    subCategories: [
      { name: "Herbal & Natural Leaf Powder", path: "herbal_natural_leaf_powder"},
      { name: "Root Powder", path: "root_powder" },
      { name: "Seed & Bark Powder", path: "seed_bark_powder" },
      { name: "Rhizome & Tuber Powder", path: "rhizome_tuber_powder" },
      { name: "Flower & Fruit Powder", path: "flower_fruit_powder" },
      { name: "Food Powders", path: "food_powder" },
    ],
  },
  // {
  //   name: "Premium Quality Chips & More",
  //   icon: category3,
  //   path:"chips_and_more",
  //   subCategories: [
  //     { name: "Chips", path: "chips" },
  //     { name: "Murukku", path: "murukku" },
  //     { name: "Halwa", path: "halwa" },
  //     { name: "Chikki", path: "chikki" }
  //   ],
  // },
  // {
  //   name: "Frozen Foods",
  //   icon: category4,
  //   path:"frozen_food",
  //   subCategories: [
  //     { name: "Fries & Snacks", path: "fries_snacks" },
  //     { name: "Patties & Tikkis", path: "patties_tikkis" },
  //     { name: "Crispy Bites", path: "crispy_bites" },
  //     { name: "Plant-Based Mains", path: "plant_based" }
  //   ],
  // }
];
